export default {"src":"/_next/static/media/landscaping.6aa32109.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};